<template>
    <div class="flex flex-col items-center">
        <button class="flex items-center gap-4" @click="toggleDropdown">
            <span
                class="flex-none w-48 h-48 rounded mr-12 border border-primary-80"
                :style="{ backgroundColor: background }"
            ></span>
            <div class="flex flex-col text-start leading-tight">
                <span class="font-semibold uppercase text-primary-20 mb-4">
                    <slot />
                </span>
                <span class="text-body-sm text-primary-20">
                    <slot name="description" />
                </span>
            </div>
        </button>
        <div :class="showDropdown ? 'max-h-600' : 'max-h-0'" class="overflow-hidden transition-all">
            <div
                v-if="showDropdown"
                class="w-fit mx-auto rounded overflow-hidden shadow mt-12"
            >
                <Chrome
                    v-model="internalColor"
                    :inline="true"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { Chrome } from '@ckpack/vue-color'

const props = defineProps({
    color: {
        type: Object,
        required: true,
        default: () => ({ h: 0, s: 0, l: 0, a: 1 })
    },
    background: {
        type: String,
        required: true
    }
})

const emit = defineEmits(['color-change'])

const showDropdown = ref(false)
const toggleDropdown = () => {
    showDropdown.value = !showDropdown.value
}

const internalColor = ref({ hsl: { ...props.color } })

watch(
    () => props.color,
    (newColor) => {
        if (!isColorEqual(newColor, internalColor.value.hsl)) {
            internalColor.value = { hsl: { ...newColor } }
        }
    },
    { deep: true, immediate: true }
)

watch(
    () => internalColor.value,
    (newVal) => {
        if (newVal?.hsl) {
            const updatedColor = { ...newVal.hsl }
            // Only emit if there's a meaningful change
            if (!isColorEqual(updatedColor, props.color)) {
                emit('color-change', updatedColor)
            }
        }
    },
    { deep: true }
)

function isColorEqual(color1, color2) {
    return (
        color1.h === color2.h &&
        color1.s === color2.s &&
        color1.l === color2.l &&
        color1.a === color2.a
    )
}

onMounted(() => {
    internalColor.value = { hsl: { ...props.color } }
})
</script>
